import { Checkbox } from '@/components/ui/checkbox';
import { useId } from 'react';

export const contactConsentChannels = [
  ['sms', 'SMS'],
  ['whatsapp', 'WhatsApp'],
  ['email', 'Email'],
  ['facebook_messenger', 'Messenger'],
  ['instagram_dm', 'Instagram'],
] as const;

export type ContactConsentChannel = (typeof contactConsentChannels)[number][0];
export type ContactConsentValues = Record<ContactConsentChannel, boolean>;

export function CustomerContactConsent({
  values,
  onChange,
  disabled = false,
  available,
}: {
  values: ContactConsentValues;
  onChange: (channel: ContactConsentChannel, checked: boolean) => void;
  disabled?: boolean;
  available?: ContactConsentValues;
}) {
  const id = useId();
  return (
    <fieldset className="space-y-4" disabled={disabled}>
      <legend className="font-medium text-sm">Contact consent</legend>
      <p className="text-muted-foreground text-sm">
        Record permission given by the client.
      </p>
      <div className="space-y-3">
        {contactConsentChannels.map(([channel, label]) => (
          <label
            key={channel}
            htmlFor={`${id}-${channel}`}
            className="flex w-fit items-center gap-3 text-sm"
          >
            <Checkbox
              id={`${id}-${channel}`}
              checked={values[channel]}
              disabled={disabled || available?.[channel] === false}
              onCheckedChange={(checked) => onChange(channel, checked === true)}
            />
            {label}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
